import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/messages/")({
  staticData: {
    title: "edge.navigation.messages",
  },
});
